module.exports = __webpack_public_path__ + "img/bug.4c071118.svg";